import {Component, Inject} from '@angular/core';
import {
    MAT_DIALOG_DATA,
    MatDialogActions,
    MatDialogClose,
    MatDialogContent,
    MatDialogRef
} from '@angular/material/dialog';
import {Opportunity} from '../../interfaces/opportunity.interface';
import {OpportunityService} from '../../services/opportunity.service';
import {UntypedFormGroup} from '@angular/forms';
import {AuthService} from '../../../services/auth.service';
import {FollowUp} from '../../interfaces/follow-up.interface';
import {DataService} from '../../../services/data.service';
import {FollowUpFormComponent} from '../follow-up-form/follow-up-form.component';
import {MatButton} from '@angular/material/button';



@Component({
    selector: 'app-follow-up-creation',
    imports: [
        FollowUpFormComponent,
        MatDialogActions,
        MatButton,
        MatDialogClose,
        MatDialogContent
    ],
    templateUrl: 'follow-up-creation-dialog.component.html'
})
export class FollowUpCreationDialogComponent {

    formGroup: UntypedFormGroup;
    saving = false;

    constructor(
        private dialogRef: MatDialogRef<FollowUpCreationDialogComponent>,
        private opportunityService: OpportunityService,
        @Inject(MAT_DIALOG_DATA) public opportunity: Opportunity,
        private authService: AuthService,
        private dataService: DataService
    ) {
        this.formGroup = this.opportunityService.getEmptyFollowUpForm();
        this.formGroup.get('createdBy').setValue(this.authService.currentUser.email);
        this.formGroup.get('createdAt').setValue(new Date());
    }

    save() {
        this.saving = true;
        const formValue: FollowUp = this.formGroup.getRawValue();
        this.opportunityService.updateForecastAmountsValue(formValue);
        this.opportunityService.transformDatesBeforeSave(formValue);
        this.dataService.createNewFollowUp(formValue).then(() => {
            console.log('Follow-up successfully added');
            this.saving = false;
            this.dialogRef.close();
        }).catch(error => {
            console.error('Error creating follow-up: ', error);
            this.saving = false;
        });
    }
}